import React from 'react';
import { Grid, Paper, Box, Typography } from '@mui/material';

import { CatalogSearchResultListItem } from '@backstage/plugin-catalog';
import { SearchType } from '@backstage/plugin-search';
import {
  SearchBar,
  SearchFilter,
  SearchResult,
  SearchPagination,
} from '@backstage/plugin-search-react';
import {
  CatalogIcon,
  DocsIcon,
} from '@backstage/core-components';
import { TechDocsSearchResultListItem } from '@backstage/plugin-techdocs';

const SearchPage = () => {
  return (
    <Box sx={{ padding: 3 }}>
      <Typography variant="h4" component="h1" gutterBottom>
        Search
      </Typography>
      <Box sx={{ marginTop: 2 }}>
        <Grid container direction="row">
          <Grid item xs={12}>
            <Paper sx={{ padding: (theme) => theme.spacing(1, 0) }}>
              <SearchBar debounceTime={100} />
            </Paper>
          </Grid>
          <Grid item xs={3}>
            <SearchType.Accordion
              name="Result Type"
              defaultValue="software-catalog"
              types={[
                {
                  value: 'software-catalog',
                  name: 'Software Catalog',
                  icon: <CatalogIcon />,
                },
                {
                  value: 'techdocs',
                  name: 'Documentation',
                  icon: <DocsIcon />,
                },
              ]}
            />
            <Paper
              sx={{
                padding: (theme) => theme.spacing(2),
                marginTop: (theme) => theme.spacing(2),
                '& > *:not(:first-of-type)': {
                  marginTop: (theme) => theme.spacing(2.5),
                },
              }}
            >
              <SearchFilter.Select
                label="Kind"
                name="kind"
                values={['Component', 'Template']}
              />
              <SearchFilter.Checkbox
                label="Lifecycle"
                name="lifecycle"
                values={['experimental', 'production']}
              />
            </Paper>
          </Grid>
          <Grid item xs={9}>
            <SearchPagination />
            <SearchResult>
              <CatalogSearchResultListItem icon={<CatalogIcon />} />
              <TechDocsSearchResultListItem icon={<DocsIcon />} />
            </SearchResult>
          </Grid>
        </Grid>
      </Box>
    </Box>
  );
};

export const searchPage = <SearchPage />;
